<template>
  <v-container>
    <v-form ref="form" v-model="valid" :lazy-validation="false">
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <div>
            <h1>My Account</h1>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col offset-md="2" cols="6" md="4">
          <v-text-field
            v-model="formData.firstName"
            :rules="validation.firstName"
            label="Frist name"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="4">
          <v-text-field
            v-model="formData.lastName"
            :rules="validation.lastName"
            label="Last name"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-text-field
            label="E-mail"
            v-model="formData.email"
            :rules="validation.email"
            persistent-hint
            outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-text-field
            v-model="formData.username"
            :rules="validation.username"
            :disabled="true"
            label="User name"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="4" offset-md="2">
          <v-btn block color="primary" :loading="loading" @click="updateUser">Save</v-btn>
        </v-col>
        <v-col cols="6" md="4">
          <v-btn block color="teal" :loading="loading" @click="resetPassword()">Reset Password</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <modal-confirm
      :active="modal"
      :confirm-text="`Login`"
      :title="'Reset Password'"
      :message="`Please open your email for reset password`"
      :show-cancel="false"
      @onConfirm="() => { $router.push({ name: 'Login' })}" />
  </v-container>
</template>

<script>
import UserProvider from '@/resources/UserProvider'
import ModalConfirm from '@/components/ModalConfirm'
import { mapActions } from 'vuex'
import AuthProvider from '@/resources/AuthProvider'
const authService = new AuthProvider()
const userService = new UserProvider()
export default {
  components: {
    ModalConfirm
  },
  data: () => ({
    modal: false,
    loading: false,
    image: null,
    valid: false,
    formData: {
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      role: ''
    },
    validation: {
      firstName: [
        v => !!v || 'This feild is require.'
      ],
      lastName: [
        v => !!v || 'This feild is require.'
      ],
      email: [
        v => !!v || 'This feild is require.',
        v => /.+@.+/.test(v) || 'Incorrect email.'
      ],
      username: [
        v => !!v || 'This feild is require.'
      ],
      role: [
        v => !!v || 'This feild is require.'
      ]
    }
  }),
  computed: {
    userId () {
      return this.$route.params.id ? this.$route.params.id : 0
    }
  },
  async mounted () {
    this.loading = true
    await this.getUser()
    this.loading = false
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    async getUser () {
      try {
        const { data } = await userService.getUserById(this.userId)
        this.formData = {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          username: data.username,
          role: data.role
        }
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      }
    },
    async resetPassword () {
      try {
        this.loading = true
        await authService.resetPassword(this.formData.username)
        this.modal = true
      } catch (err) {
        this.snackbar = {
          value: true,
          type: 'pink',
          message: err.message
        }
      } finally {
        this.loading = false
      }
    },
    async updateUser () {
      this.$refs.form.validate()
      if (this.valid) {
        try {
          this.loading = true
          const { data } = await userService.updateUser(this.userId, this.formData)
          if (data) {
            this.setSnackbar({
              message: 'Update user success.',
              type: 'success',
              active: true
            })
            this.$router.push({ name: 'Main'})
          }
        } catch (err) {
          this.setSnackbar({
            message: err.message,
            type: 'pink',
            active: true
          })
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.img-panel {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
}

.remove-img-btn {
  position: absolute;
  margin-right: -10px !important;
  margin-top: -10px !important;
}
</style>
